import { render } from "./RemoteWork.vue?vue&type=template&id=e9975a52"
import script from "./RemoteWork.vue?vue&type=script&lang=js"
export * from "./RemoteWork.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__